<template>
  <main class="px-4 pt-4">
    <h1 class="mb-0">
      {{ $t('Terminal Utro') }}
    </h1>
    <dx-data-grid
      ref="terminalUtroGrid"
      :data-source="dataSource"
      :remote-operations="remoteOperations"
      :allow-column-reordering="false"
      :show-borders="true"
      :column-min-width="50"
      :column-auto-width="true"
      :allow-column-resizing="true"
      column-resizing-mode="widget"
      :hover-state-enabled="true"
      @toolbar-preparing="onToolbarPreparing"
    >
      <dx-column
        data-field="freight_order_date"
        :caption="$t('freight order date')"
        data-type="date"
        :allow-search="false"
        :allow-editing="false"
      />
      <dx-column
        data-field="container"
        :caption="$t('Container')"
        :allow-editing="false"
        :fixed="true"
      />

      <dx-column
        data-field="container_prefix"
        :caption="$t('utro.container prefix')"
        :allow-editing="false"
      />
      <dx-column
        data-field="container_number"
        :caption="$t('utro.container number')"
        :allow-editing="false"
      />
      <dx-column
        data-field="container_type"
        :caption="$t('container type')"
        :allow-editing="false"
      />
      <dx-column
        data-field="container_owner"
        :caption="$t('utro.container owner')"
        :allow-search="false"
      />
      <dx-column
        data-field="terminal_departure_station"
        :caption="$t('utro.terminal departure station')"
        :allow-editing="false"
        :allow-search="false"
      />
      <dx-column
        data-field="terminal_shipper"
        :caption="$t('utro.terminal shipper')"
        :allow-editing="false"
        :allow-search="false"
      />
      <dx-column
        data-field="freight_order_destination"
        :caption="$t('utro.freight order destination station')"
        :allow-editing="false"
        :allow-search="false"
      />
      <dx-column
        data-field="consignee"
        :caption="$t('consignee')"
        :allow-editing="false"
        :allow-search="false"
      />
      <dx-column
        data-field="destination_country"
        :caption="$t('destination country')"
        :allow-editing="false"
        :allow-search="false"
      />

      <dx-column
        data-field="freight_description"
        :caption="$t('freight description')"
        :allow-editing="false"
        :allow-search="false"
      />
      <dx-column
        data-field="packing_kind"
        :caption="$t('count and packing kind')"
        :allow-editing="false"
        :allow-search="false"
      />
      <dx-column
        data-field="container_tare"
        :caption="$t('container tare')"
        :allow-editing="false"
        :allow-search="false"
      />
      <dx-column
        data-field="freight net weight"
        :caption="$t('freight net weight')"
        :allow-editing="false"
        :allow-search="false"
      />
      <dx-column
        data-field="freight_grossweight"
        :caption="$t('freight gross weight')"
        :allow-editing="false"
        :allow-search="false"
      />
      <dx-column
        data-field="seal_numbers"
        :caption="$t('seal numbers')"
      />
      <dx-column
        data-field="notes"
        :caption="$t('notes')"
        :allow-editing="false"
        :allow-search="false"
      />
      <dx-column
        data-field="special_conditions"
        :caption="$t('utro.special conditions')"
      />
      <dx-column
        data-field="documents"
        :caption="$t('Documents')"
        :allow-search="false"
      />
      <dx-column
        data-field="Дата завоза контейнера"
        :caption="$t('Дата завоза контейнера')"
        :allow-search="false"
      />
      <dx-column
        data-field="Номер накладной"
        :caption="$t('Номер накладной')"
        :allow-editing="false"
        :allow-search="false"
      />
      <dx-column
        data-field="ГУ-12"
        :caption="$t('ГУ-12')"
        :allow-editing="false"
        :allow-search="false"
      />
      <dx-column
        data-field="№отправки (этран)"
        :caption="$t('№отправки (этран)')"
        :allow-editing="false"
        :allow-search="false"
      />
      <dx-column
        data-field="№ вагона"
        :caption="$t('№ вагона')"
        :allow-editing="false"
        :allow-search="false"
      />
      <dx-column
        data-field="модель пл"
        :caption="$t('модель пл')"
        :allow-editing="false"
        :allow-search="false"
      />
      <dx-column
        data-field="Оплата для Утро"
        :caption="$t('Оплата для Утро')"
        :allow-editing="false"
        :allow-search="false"
      />
      <dx-column
        data-field="company"
        :caption="$t('client')"
        :lookup="companyLookup"
        :allow-editing="false"
        :allow-search="false"
      />

      <dx-group-panel :visible="true" />
      <dx-editing
        v-if="user.is_manager"
        :allow-updating="true"
        :use-icons="true"
        mode="cell"
      />
      <dx-header-filter :visible="true" />
      <dx-search-panel
        :visible="true"
        :highlight-case-sensitive="false"
      />
      <dx-export
        :enabled="true"
        :allow-export-selected-data="true"
        file-name="utro"
      />
      <dx-column-chooser :enabled="true" />
      <dx-state-storing
        :enabled="true"
        type="localStorage"
        :storage-key="`u${user.id}-monitoring-grid-storage`"
      />
      <dx-paging :page-size="20" />
      <dx-pager
        :show-page-size-selector="true"
        :allowed-page-sizes="[10, 15, 20, 50]"
      />
    </dx-data-grid>
  </main>
</template>

<script>
import {
  DxDataGrid,
  DxExport,
  DxColumn,
  DxColumnChooser,
  DxEditing,
  DxHeaderFilter,
  DxGroupPanel,
  DxSearchPanel,
  DxSelection,
  DxStateStoring,
  DxPaging,
  DxPager,
} from 'devextreme-vue/data-grid';


import { mapState } from 'vuex';
import ruMessages from 'devextreme/localization/messages/ru.json';
import { locale as localize, loadMessages } from 'devextreme/localization';

import { DxButton } from 'devextreme-vue';
import { DxCustomRule } from 'devextreme-vue/validator';
import createCustomStore from '@/utils/create-custom-store';
import createFreightOrderLookup from '@/utils/create-freight-order-lookup';

export default {
  name: 'TerminalUtro',
  components: {
    DxDataGrid,
    DxColumn,
    DxGroupPanel,
    DxSearchPanel,
    DxEditing,
    DxHeaderFilter,
    DxExport,
    DxColumnChooser,
    DxSelection,
    DxStateStoring,
    DxPaging,
    DxPager,
    DxButton,
    DxCustomRule,
  },
  data: (vue) => ({
    remoteOperations: {
      sorting: true,
      filtering: true,
      paging: true,
    },
    dataSource: createCustomStore('tracking/api/reports/terminal-utro/'),
    freightOrderLookup: createFreightOrderLookup(vue),
  }),
  computed: {
    ...mapState(['user']),
    companyLookup: () => ({
      dataSource: {
        store: createCustomStore('profile/api/companies/'),
        key: 'id',
      },
      valueExpr: 'id',
      displayExpr(company) {
        return company ? `${company.name} ${company.inn || ''}` : '';
      },
      allowClearing: true,
    }),
  },
  created() {
    loadMessages(ruMessages);
    localize(this.$i18n.locale);
  },
  methods: {
    onToolbarPreparing(e) {
      e.toolbarOptions.items.unshift({
        location: 'after',
        widget: 'dxButton',
        hint: this.$t('refresh'),
        options: {
          icon: 'ace-icon icon-refresh',
          hint: this.$t('refresh'),
          onClick: this.refreshDataGrid.bind(this),
        },
      }, {
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'ace-icon icon-close',
          hint: this.$t('clear_filters'),
          onClick: this.clearFilter.bind(this),
        },
      });
    },
    refreshDataGrid() {
      this.$refs.terminalUtroGrid.instance.refresh();
    },
    clearFilter() {
      this.$refs.terminalUtroGrid.instance.clearFilter();
    },
  },
};
</script>
